import { QueryDtoOf } from '@40seas/entities/common';
import { BankAccount } from './bank-account.entity';

export class QueryBankAccountDto extends QueryDtoOf(BankAccount) {}
